import { useState } from "react";
import {
    migrateKurdishTalentCmsAuth,
    KT_CMS_TOKEN_KEY,
    KT_CMS_USER_KEY,
} from "../../utils/authStorageKeys";
import { resolveMediaUrl } from "../../utils/Network";

migrateKurdishTalentCmsAuth();

export const logout = () => {
    removeUserSession();
}

export const isLogin = () => {
    migrateKurdishTalentCmsAuth();
    if (localStorage.getItem(KT_CMS_TOKEN_KEY)) {
        return true;
    }

    return false;
}

export const getAge = (birthday) => {

    if (birthday){
        var year = birthday.split('-')[0];
        if (year) {
            var current_year = new Date().getFullYear()
            return current_year - year;
        }
    }
    
}

// return the user data from the session storage
export const getUser = () => {
    migrateKurdishTalentCmsAuth();
    const userStr = localStorage.getItem(KT_CMS_USER_KEY);
    if (userStr) return JSON.parse(userStr);
    else return null;
}

export const isAdmin = () => {
  migrateKurdishTalentCmsAuth();
  const userStr = localStorage.getItem(KT_CMS_USER_KEY);
    if (userStr) {
        var user = JSON.parse(userStr);
        if (user.role === "admin") return true;
        return false;
  };
  return false;
};

export function mediaSrc(raw, fallback = "/assets/images/default.png") {
    if (!raw) return fallback;
    return resolveMediaUrl(raw);
}

export function talentImageSrc(item, fallback = "/assets/images/default.png") {
    return mediaSrc(item?.image_url || item?.image, fallback);
}

export const userAvatar = (user)=>{
    if (!user) {
        return "/assets/dist/img/avatar-m.jpeg";
    }
    const src = user.avatar || user.image;
    if (src) {
        return resolveMediaUrl(src);
    }
    return user?.gender == "1" || user?.gender === 1
        ? "/assets/dist/img/avatar-f.jpeg"
        : "/assets/dist/img/avatar-m.jpeg";
}

export function BadgeClass(value) {

    if (value < 30) {

        return "badge bg-red mr-10";
    }
    else if (value < 50) {
        return "badge bg-yellow mr-10";
    }
    else if (value < 70) {
        return "badge bg-light-blue mr-10";
    }
    else if (value <= 100) {
        return "badge bg-green mr-10";
    }


}

export const isEditor = () => {
    migrateKurdishTalentCmsAuth();
    const userStr = localStorage.getItem(KT_CMS_USER_KEY);
      if (userStr) {
          var user = JSON.parse(userStr);
          if (user.role === "editor") return true;
          return false;
    };
    return false;
  };

/** True when `/cms/login` staff session exists (admin or editor). Not the public site JWT. */
export const isCmsStaff = () => isAdmin() || isEditor();

export const CMS_LOGIN_PATH = "/cms/login";

export function isCmsLoginPath(pathname) {
    const path = String(pathname || "").replace(/\/+$/, "") || "/";
    return path === "/cms/login" || path === "/cms/signin";
}

function cmsJwtIsExpired(token) {
    if (!token) return true;
    const parts = String(token).split(".");
    if (parts.length < 2) return true;
    try {
        const json = atob(parts[1].replace(/-/g, "+").replace(/_/g, "/"));
        const payload = JSON.parse(json);
        if (payload == null || payload.exp == null) return false;
        return payload.exp * 1000 <= Date.now() + 5000;
    } catch (e) {
        return true;
    }
}

/** Valid CMS JWT plus admin/editor role. Expired tokens do not count as logged in. */
export const canAccessCms = () => {
    const token = getToken();
    if (!token || cmsJwtIsExpired(token)) return false;
    return isCmsStaff();
};

let cmsLoginRedirecting = false;

export function redirectToCmsLogin() {
    if (typeof window === "undefined") return;
    removeUserSession();
    if (isCmsLoginPath(window.location.pathname)) return;
    if (cmsLoginRedirecting) return;
    cmsLoginRedirecting = true;
    window.location.replace(CMS_LOGIN_PATH);
}

export function getRange(start, end) {
    return Array.apply(0, Array(end))
        .map((element, index) => index + start);
}

// return the token from the session storage
export const getToken = () => {
    migrateKurdishTalentCmsAuth();
    return localStorage.getItem(KT_CMS_TOKEN_KEY) || null;
}

// remove the token and user from the session storage
export const removeUserSession = () => {
    localStorage.removeItem(KT_CMS_TOKEN_KEY);
    localStorage.removeItem(KT_CMS_USER_KEY);
}

// set the token and user from the session storage
export const setUserSession = (token, user) => {
    localStorage.setItem(KT_CMS_TOKEN_KEY, token);
    localStorage.setItem(KT_CMS_USER_KEY, JSON.stringify(user));
}

export const useFormInput = initialValue => {
    const [value, setValue] = useState(initialValue);

    const handleChange = e => {
        setValue(e.target.value);
    }
    return {
        value,
        onChange: handleChange
    }
}

export const getDefaultName = (item_names) => {

    if (item_names) {
        let default_name = item_names.find(x => x.language.id == 3);
        if (default_name)
            return default_name.name
        else {
            let default_name = item_names.find(x => x.language == 3);
            if (default_name)
                return default_name.name
            else if (item_names.length>0) return item_names[0].name;
        }
        
    }
    return "";

}

export const timeSince = function (date) {
    if (typeof date !== 'object') {
        date = new Date(date);
    }

    var seconds = Math.floor((new Date() - date) / 1000);
    var intervalType;

    var interval = Math.floor(seconds / 31536000);
    if (interval >= 1) {
        intervalType = 'year';
    } else {
        interval = Math.floor(seconds / 2592000);
        if (interval >= 1) {
            intervalType = 'month';
        } else {
            interval = Math.floor(seconds / 86400);
            if (interval >= 1) {
                intervalType = 'day';
            } else {
                interval = Math.floor(seconds / 3600);
                if (interval >= 1) {
                    intervalType = "hour";
                } else {
                    interval = Math.floor(seconds / 60);
                    if (interval >= 1) {
                        intervalType = "minute";
                    } else {
                        interval = seconds;
                        intervalType = "second";
                    }
                }
            }
        }
    }

    if (interval > 1 || interval === 0) {
        intervalType += 's';
    }

    return interval + ' ' + intervalType;
};

export const isImage = path => {
    if(!path) return false;
    var fileType = path.split('.').pop();
    var validImageTypes = ["gif", "GIF", "jpeg", "JPEG", "jpg", "JPG", "png", "PNG"];
    if (validImageTypes.includes(fileType)) {
        return true
    }
    else return false;

}
export const getFileName = function (str) {
    return str.replace(/^.*(\\|\/|\:)/, '');
}

export const MB = function (file_size) {
    if (!file_size) return "";
    return file_size*(1024*1024);
}

export const FromMB = function (file_size) {
    if (!file_size) return "";
    return  Math.round(file_size / (1024 * 1024));
}

export function isNumber(value) {
    return /^-?\d+$/.test(value);
}

export function sortByKey(array, key) {
    return array.sort(function (a, b) {
        //console.log(a["names"][0])
        var x = a["names"][0]["name"]; var y = b["names"][0]["name"];
        return ((x < y) ? -1 : ((x > y) ? 1 : 0));
    });
}
export function sortDegreeReport(array, key) {
    return array.sort(function (a, b) {
        //console.log(a["names"][0])
        var x = parseFloat(a["total"]); var y = parseFloat(b["total"]);
        return ((x > y) ? -1 : ((x < y) ? 1 : 0));
    });
}
export function sortLanguages(array) {
    return array.sort(function (a, b) {
        var x = a["is_default"]; var y = b["is_default"];
        return ((x > y) ? -1 : ((x < y) ? 1 : 0));
    });
}
export const toTime = function (time) {
    var minutes = Math.floor(time / 60);
    var seconds = time - minutes * 60;
    if (minutes + seconds > 0) return minutes + ":" + seconds;
    else return ""


}
export function sortCities(array) {
    return array.sort(function (a, b) {
        //console.log(a["names"][0])
        
        var x = a["names"][0]["name"]; var y = b["names"][0]["name"];
        return ((x < y) ? -1 : ((x > y) ? 1 : 0));
    });
}
export const BuildTalents = (talents,active_only) => {

    if (talents) {
        var parents = [];
        
        if(active_only)
            parents = talents.filter(x => !x.parent && x.status );
        else
            parents = talents.filter(x => !x.parent);

        parents.forEach(parent => {
            parent.childs = getChilds(talents, parent.id, active_only)
        })

        return parents;
    }

}
export const buildReports = (reports) => {

    if (reports) {
        reports.map(item=>{
            let questions = item[0].questions;

            let people_degree = item[0].peopledegree_average.degree__avg

            let avg_sum = 0;
            let weight_sum = 0;

            questions && questions.forEach(question_item => {
                avg_sum += question_item.avg * question_item.question.weight
                weight_sum += question_item.question.weight
            })

            let total = avg_sum / weight_sum * 10
            if(people_degree>0)
                total = total * 0.9 + people_degree 
            item.total = total.toFixed(2);
            return item
        })
    }

    reports= sortDegreeReport(reports)

    return reports

}

export const getDate = (dateString) => {

    if(!dateString) return
    var dateObject = new Date(dateString);
    let str = dateObject.toISOString();
    let date = str.split('T')[0]
    let time = str.split('T')[1]
    time = time.split('.')[0]
    return date + " "+ time

}

export const BuildCategories = (categories, active_only) => {

    if (categories!= null) {
        var parents = [];

        if (active_only)
            parents = categories.filter(x => !x.parent && x.status);
        else
            parents = categories.filter(x => !x.parent);

        parents.forEach(parent => {
            parent.childs = getChilds(categories, parent.id, active_only)
        })

        return parents;
    }

}
export const getChilds = (all_talents, talent_id, active_only) => {

    var childs = [];
    if (active_only)
        childs = all_talents.filter(x => x.parent === talent_id && x.status);
    else
        childs = all_talents.filter(x => x.parent === talent_id);
    childs.forEach(item => {
        item.childs = getChilds(all_talents, item.id, active_only)
    })
    return childs;

}

export const isYoutube = (path) => {
    if(!path) return false;
    if (path.includes("youtube.com") || path.includes("youtu.be")) return true
    return false
  
  };
  
export const getYoutubeId = (url) => {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
  
    return (match && match[2].length === 11)
        ? match[2]
        : null;
}